export const languages = ['en', 'hu', 'sr'];

export const languageDateMasks = {
  fr: '__/__/____',
  en: '__/__/____',
  ru: '__.__.____',
  de: '__.__.____',
};
